import * as React from 'react';
import type { SVGProps } from 'react';
const SvgIdentities = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    fill="currentColor"
    {...props}
  >
    <g opacity={0.9}>
      <path
        fillRule="evenodd"
        d="M16.227 18.09c1.158 0 2.127-.927 1.8-2.003-.893-2.949-3.707-5.102-7.042-5.102s-6.149 2.153-7.042 5.102c-.326 1.076.643 2.004 1.8 2.004h10.484Z"
        clipRule="evenodd"
      />
      <path d="M14.13 6.924c0 1.682-1.408 3.045-3.145 3.045S7.84 8.606 7.84 6.924s1.408-3.046 3.145-3.046 3.145 1.364 3.145 3.046" />
    </g>
  </svg>
);
export default SvgIdentities;
